// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.apexcharts-datalabels {
  font-weight: bold; /* Make the font bold */
  -webkit-text-stroke: 20px #000; /* Add a stroke (outline) to the text */
  text-shadow: 0px 0px 0px rgba(0, 0, 0, 0); /* Add a shadow to the text */
}

.chart-container {
  width: 500px;
  height: 500px;
}

.legend {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}

.legend-item label {
  margin-left: 5px;
}

.legend-icon {
  z-index: 1600 !important;
  width: 14px;
  height: 14px;
  border-radius: 8px;
  display: inline-block;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
